import { render, staticRenderFns } from "./TiposDocumentosPersonaLayout.vue?vue&type=template&id=99c41a84&scoped=true"
import script from "./TiposDocumentosPersonaLayout.vue?vue&type=script&lang=js"
export * from "./TiposDocumentosPersonaLayout.vue?vue&type=script&lang=js"
import style0 from "./TiposDocumentosPersonaLayout.vue?vue&type=style&index=0&id=99c41a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c41a84",
  null
  
)

export default component.exports